
define(function(require){
    var _ = require('underscore'),
        Backbone = require('backbone'),
        BaseModel = require('common/models/OEBaseModel'),
        Country = BaseModel.extend();

    return Backbone.Collection.extend({
    	model: Country
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/location-service/models/Country.js
// module id = 103
// module chunks = 25 26